import { createUseStyles } from 'react-jss'

import { darkGrey } from '../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  requiredCreativeSizesContainer: {
    color: darkGrey,
    fontWeight: 700
  },
  videoAndImageRow: {
    display: 'flex',
    gap: 16,
    marginTop: 10
  },
  column: {
    flex: 1
  },
  title: {
    marginBottom: 14
  }
})

export default useStyles
